export default {
  ORGANISATION_USERS_WITH_SAME_DOMAIN ({ organisationUsersWithSameDomain }) {
    return organisationUsersWithSameDomain
  },
  ORGANISATION_USERS ({ organisationUsers }) {
    return organisationUsers
  }
}
